import { type FC } from 'react';
import cx from 'classnames';
import styles from './ComingSoonBadge.module.css';

type Props = {
  label: string;
  /** Positioning comes from the parent (the pill itself is `position: absolute`). */
  className?: string;
};

/**
 * Gold "Coming soon" pill marking a scene that isn't built yet. Shared by the
 * historical-scenes slider card (design `3060:12606`) and the menu's historical
 * card (design `2860:38263`) — identical pill in both, only the anchor differs,
 * so the parent supplies `top` / centering via `className`.
 */
export const ComingSoonBadge: FC<Props> = ({ label, className }) => (
  <span className={cx(styles.badge, className)}>{label}</span>
);
